export default __webpack_public_path__ + "static/media/BG.f043af61.png";